import { render, staticRenderFns } from "./gift-info.vue?vue&type=template&id=a59a2e76&scoped=true&"
import script from "./gift-info.vue?vue&type=script&lang=js&"
export * from "./gift-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59a2e76",
  null
  
)

export default component.exports